module.exports = {
  FlashObject: {
    PluginName: "Flash Nesnesi",
    config: "Konfigurasyon",
  },
};
